import React from 'react'
import Products from '../Components/Products'
import Header from '../Components/Header'
import MarqueeComponent from '../Components/Marquee/MarqueeComponent'
import Footer from '../Components/Footer'
import DaimondBanner from '../Components/DaimondBanner'


const Product = () => {
  return (
    <>
      <Header />
      <Products />
      <DaimondBanner />
      <MarqueeComponent />
      <Footer />

    </>
  )
}

export default Product